<div class="padding">
  <mat-card>
    <mat-card-content>
      @if (dataSource && dataSource.data.length > 0) {
        <div class="table-container">
          <h3>{{ 'databaseOverview.databasesOverview' | transloco }}</h3>
          <!-- Databases overview table -->
          @if (dataSource.data.length > 0) {
            <table mat-table matSort [dataSource]="dataSource" multiTemplateDataRows
              >
              <ng-container matColumnDef="databaseName">
                <th mat-header-cell *matHeaderCellDef id="databaseName" mat-sort-header
                sortActionDescription="Sort by database name."> {{ 'databaseOverview.databaseName' | transloco }} </th>
                <td mat-cell *matCellDef="let datbaseOverview"> {{datbaseOverview.databaseName}} </td>
              </ng-container>
              <ng-container matColumnDef="numPendings">
                <th mat-header-cell *matHeaderCellDef id="numPendings" mat-sort-header
                  sortActionDescription="Sort by number of pending orders.">
                  {{ 'databaseOverview.pendings' | transloco }}
                </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numPendings === 0"
                      [ngStyle]="getPendingColour(databaseOverview.oldestPending)"
                      (click)="onViewPendings(databaseOverview)">
                      {{ databaseOverview.numPendings }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numHighVolume">
                <th mat-header-cell *matHeaderCellDef id="numHighVolume" mat-sort-header
                sortActionDescription="Sort by number of High Volume orders."> {{ 'databaseOverview.highVolume' | transloco }} </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numHighVolume === 0"
                      [ngStyle]="getHighVolumeColour(databaseOverview.oldestHighVolume)"
                      (click)="onViewHighVolume(databaseOverview)">
                      {{ databaseOverview.numHighVolume }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numRequestedAtRegistry">
                <th mat-header-cell *matHeaderCellDef id="numRequestedAtRegistry" mat-sort-header
                  sortActionDescription="Sort by number of Requested at Registry orders.">
                  {{ 'databaseOverview.requestedAtRegistry' | transloco }}
                </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numRequestedAtRegistry === 0"
                      [ngStyle]="getRequestedAtRegistryColour(databaseOverview.oldestRequestedAtRegistry)"
                      (click)="onViewRequestedAtRegistry(databaseOverview)">
                      {{ databaseOverview.numRequestedAtRegistry }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numOutOfRegistryHours">
                <th mat-header-cell *matHeaderCellDef id="numOutOfRegistryHours" mat-sort-header
                  sortActionDescription="Sort by number of Out of Registry Hours orders.">
                  {{ 'databaseOverview.outOfRegistryHours' | transloco }}
                </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numOutOfRegistryHours === 0"
                      (click)="onViewOutOfHours(databaseOverview)">
                      {{ databaseOverview.numOutOfRegistryHours }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numRegistryOutage">
                <th mat-header-cell *matHeaderCellDef id="numRegistryOutage" mat-sort-header
                sortActionDescription="Sort by number of Registry Outage orders."> {{ 'databaseOverview.registryOutage' | transloco }} </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numRegistryOutage === 0"
                      (click)="onViewRegistryOutage(databaseOverview)">
                      {{ databaseOverview.numRegistryOutage }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numInvalids">
                <th mat-header-cell *matHeaderCellDef id="numInvalids" mat-sort-header
                sortActionDescription="Sort by number of invalid orders."> {{ 'databaseOverview.invalids' | transloco }} </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numInvalids === 0"
                      [ngStyle]="getInvalidColour(databaseOverview.oldestInvalid)"
                      (click)="onViewInvalids(databaseOverview)">
                      {{ databaseOverview.numInvalids }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numStaged">
                <th mat-header-cell *matHeaderCellDef id="numStaged" mat-sort-header
                sortActionDescription="Sort by number of invalid orders."> {{ 'common.labels.staged' | transloco }} </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numStaged === 0"
                      (click)="onViewStaged(databaseOverview)">
                      {{ databaseOverview.numStaged }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="numAwaitingExternalResults">
                <th mat-header-cell *matHeaderCellDef id="numAwaitingExternalResults" mat-sort-header
                sortActionDescription="Sort by number of invalid orders."> {{ 'databaseOverview.awaitingExternal' | transloco }} </th>
                <td mat-cell *matCellDef="let databaseOverview">
                  <div class="flex-container-center">
                    <button mat-raised-button [disabled]="databaseOverview.numAwaitingExternalResults === 0"
                      (click)="onViewAwaitinExternal(databaseOverview)">
                      {{ databaseOverview.numAwaitingExternalResults }}
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          }
        </div>
      }

      <lib-placeholder iconName="cancel" iconClass="icon-warning" [message]="'databaseOverview.errorLoadingDatabaseOverview' | transloco"
      [condition]="!loading && (dataSource?.data?.length ?? 0) === 0"></lib-placeholder>

    </mat-card-content>
  </mat-card>
</div>